import { render, staticRenderFns } from "./svgCircleText.vue?vue&type=template&id=062e7e6b&"
import script from "./svgCircleText.vue?vue&type=script&lang=js&"
export * from "./svgCircleText.vue?vue&type=script&lang=js&"
import style0 from "./svgCircleText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "svgCircleText.vue"
export default component.exports